// extracted by mini-css-extract-plugin
export default {"search":"Search_search__FbOhq","icon":"Search_icon__lYud7"};